import { render, staticRenderFns } from "./autologin.vue?vue&type=template&id=56100c10&"
import script from "./autologin.vue?vue&type=script&lang=js&"
export * from "./autologin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports